/**
 * @return  生产环境使用懒加载
 */
module.exports = file => () => import(/* webpackChunkName: "[request]" */ `@/views/${file}.vue`)


// WEBPACK FOOTER //
// ./src/router/config/_import_production.js